// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bdb0","buttons":"Footer_buttons__j7qw1"};